import React, { useEffect, useState } from 'react';
import { useSettingActions } from 'src/store/settings/actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
import { getActiveBadgeBackgroundColor } from 'src/components/utilities/utils';
import Pagination from 'src/components/common/pagination';
import AddCreditJurisdiction from './AddCreditJurisdiction';
const CreditJurisdiction = () => {
  const dispatch = useDispatch();
  const settingAction = useSettingActions(dispatch);
  const [editflag, setEditFlag] = useState(false);
  const {
    creditJurisdictions,
    isCreditJurisdictionAdded,
    isCreditJurisdictionDeleted,
    creditJurisdictionPaginationMeta
  } = useSelector((state: RootState) => {
    return {
      creditJurisdictions: state.setting.creditJurisdictions,
      isCreditJurisdictionAdded: state.setting.isCreditJurisdictionAdded,
      isCreditJurisdictionDeleted: state.setting.isCreditJurisdictionDeleted,
      creditJurisdictionPaginationMeta: state.setting.creditJurisdictionPaginationMeta
    };
  });

  useEffect(() => {
    settingAction.getCreditJurisdictionsRequest({ pageNumber: 1 });
  }, []);

  useEffect(() => {
    if (isCreditJurisdictionAdded || isCreditJurisdictionDeleted) {
      settingAction.getCreditJurisdictionsRequest({ pageNumber: 1 });
    }
  }, [isCreditJurisdictionAdded, isCreditJurisdictionDeleted]);

  const handleEditClick = (id: string) => {
    settingAction.getSingleCreditJurisdictionsRequest(id);
    setEditFlag(true);
  };

  const handleDeleteClick = (id: string) => {
    settingAction.deleteCreditJurisdictionsRequest(id);
  };

  const handlePageChange = (pageNumber: any) => {
    settingAction.getCreditJurisdictionsRequest({ pageNumber });
  };
  return (
    <>
      <div className="tab-pane fade" id="tabs-jurisdiction" role="tabpanel">
        <div className="md:p-5 p-3">
          <div className="py-5 px-7">
            <div className="text-right">
              <div className="dropdown relative">
                <button
                  onClick={() => setEditFlag(false)}
                  className="btn-primary w-auto mt-0 mr-0 ml-auto mb-4"
                  type="button"
                  id="action-dropdown"
                  data-bs-toggle="modal"
                  data-bs-target="#AddCreditJurisdiction">
                  Add New
                </button>
              </div>
            </div>{' '}
            <div className={`overflow-x-auto-sm`}>
              <table className="table-auto w-full border">
                <thead className="text-xs font-semibold uppercase bg-gray-100">
                  <tr>
                    <th className="p-2">
                      <div className="font-semibold text-left">Jurisdiction Name</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">Jurisdiction Code</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">Integration Id</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">is Active</div>
                    </th>
                    <th className="p-2">
                      <div className="text-left invisible">Action</div>
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm divide-y divide-gray-100">
                  {creditJurisdictions &&
                    creditJurisdictions.map((item) => {
                      return (
                        <tr key={item.id}>
                          <td className="p-2">{item.jurisdictionName}</td>
                          <td className="p-2"> {item.jurisdictionCode}</td>
                          <td className="p-2"> {item.integrationId}</td>
                          <td className="p-2">
                            <span
                              className={`${getActiveBadgeBackgroundColor(
                                item.isActive
                              )} text-xs font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-yellow-900 dark:text-yellow-300`}>
                              {item.isActive ? 'Active' : 'In Active'}
                            </span>
                          </td>
                          <td className="p-2">
                            <div className="dropdown relative">
                              <a
                                className="
                        dropdown-toggle
                        transition
                        duration-150
                        ease-in-out border h-8 w-8 flex items-center justify-center rounded-md"
                                href="#"
                                type="button"
                                id="ActionButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <i className="fas fa-ellipsis-v"></i>
                              </a>
                              <ul
                                className="dropdown-menu action-dropdown"
                                aria-labelledby="ActionButton">
                                <li
                                  onClick={() => handleEditClick(item.id)}
                                  data-bs-toggle="modal"
                                  data-bs-target="#AddCreditJurisdiction">
                                  <span className="dropdown-item flex-items cursor-pointer">
                                    <i className="fas fa-edit w-6"></i>
                                    <span>Edit</span>
                                  </span>
                                </li>
                                <li onClick={() => handleDeleteClick(item.id)}>
                                  <span className="dropdown-item flex-items cursor-pointer text-red-500">
                                    <i className="fas fa-trash w-6"></i>
                                    <span>Delete</span>
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              {!!creditJurisdictionPaginationMeta &&
                !!Object.keys(creditJurisdictionPaginationMeta).length && (
                  <Pagination
                    currentPage={creditJurisdictionPaginationMeta.pageNumber}
                    totalCount={creditJurisdictionPaginationMeta.totalCount}
                    pageSize={creditJurisdictionPaginationMeta.pageSize}
                    onPageChange={(page: any) => handlePageChange(page)}
                  />
                )}
            </div>
          </div>
        </div>
        <AddCreditJurisdiction editflag={editflag} />
      </div>
    </>
  );
};

export default CreditJurisdiction;
